
    // TEST CONFIG --------------
    // const firebaseConfig = {
    //     apiKey: "AIzaSyBGDtg7TqHQyqFEG9DPaaKCwnXX2YExpdA",
    //     authDomain: "testchat-84139.firebaseapp.com",
    //     projectId: "testchat-84139",
    //     storageBucket: "testchat-84139.appspot.com",
    //     messagingSenderId: "98285640937",
    //     appId: "1:98285640937:web:03a1e446828f01e30fa478",
    //     measurementId: "G-P737YWGKG6"
    // };

    // CLIENT CONFIG ------------
    export const firebaseConfig = {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
        measurementId: process.env.REACT_APP_FIREBASE_MEASURMENT_ID
      };
